import { PRESENCE_STATUS, PRESENCE_TYPE  } from '../constants';

export const getPresenceIndicatorType = (presenceStatus) => {
  switch (presenceStatus) {
    case PRESENCE_STATUS.ACTIVE:
    case PRESENCE_STATUS.ONLINE:
        return PRESENCE_TYPE.ONLINE;
    case PRESENCE_STATUS.BUSY:
      return PRESENCE_TYPE.BUSY;
    case PRESENCE_STATUS.AWAY:
    case PRESENCE_STATUS.BE_RIGHT_BACK:
      return PRESENCE_TYPE.AWAY;
    case PRESENCE_STATUS.DO_NOT_DISTURB:
      return PRESENCE_TYPE.DO_NOT_DISTURB;
  }

  return PRESENCE_TYPE.OFFLINE;
};